import { useEffect } from 'react';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddWarehouse from './components/AddWarehouse';
import '../../styles/products.scss';

const WarehouseCreate = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Créer un Entrepôt');
  }, [setTitle]);

  return (
    <div className="warehouse-create-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddWarehouse />
        </Col>
      </Row>
    </div>
  );
};

export default WarehouseCreate;
